export const createMeta = vm => ({
  title: 'Bakmi GM Menu',
  // meta: {
  //   description: { name: 'description', content: 'Desty Menu description' },
  // },
  script: {
    ldJson: { type: 'application/ld+json', innerHTML: `${vm.$store.state.prefetch.storeSEO}` },
  },
  link: {
    canonical: { rel: 'canonical', href: `https://order.bakmigm.co.id${vm.$route.path}` },
    alternateId: { rel: 'alternate', href: `https://order.bakmigm.co.id${vm.$route.path}`, hreflang: 'id-id' },
    alternateEn: { rel: 'alternate', href: `https://order.bakmigm.co.id${vm.$route.path}`, hreflang: 'en-id' },
  },
})
